import { Component, Input, OnInit } from '@angular/core';

import { IconColors } from '@sondermind/iris/icon';

export interface BannerMessage {
  title: string;
  description?: string;
}

@Component({
  selector: 'sonder-success-error-banner',
  templateUrl: './success-error-banner.component.html',
  styleUrls: ['./success-error-banner.component.scss'],
  standalone: false
})
export class SuccessErrorStateBannerComponent implements OnInit {
  @Input() isSuccess: boolean;
  @Input() message: BannerMessage;

  readonly iconColors = IconColors;

  isDescriptionEmpty: boolean;

  ngOnInit(): void {
    this.isDescriptionEmpty = this.message?.description?.length === 0;
  }
}
